import React from 'react';

import { CalendarDays, Map } from 'lucide-react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import classes from '@/components/SchedulePage/ViewSwitch/style.module.scss';

const ViewSwitchComponent = ({ activeView, onChange }) => {
  const intl = useIntl();

  return (
    <div className={classes.viewSwitch} role="group" aria-label={intl.formatMessage({ id: 'VIEW_SWITCH.LABEL' })}>
      <button
        type="button"
        className={activeView === 'schedule' ? classes.active : ''}
        aria-pressed={activeView === 'schedule'}
        onClick={() => onChange('schedule')}
      >
        <CalendarDays aria-hidden="true" />
        {intl.formatMessage({ id: 'VIEW_SWITCH.SCHEDULE' })}
      </button>

      <button
        type="button"
        className={activeView === 'map' ? classes.active : ''}
        aria-pressed={activeView === 'map'}
        onClick={() => onChange('map')}
      >
        <Map aria-hidden="true" />
        {intl.formatMessage({ id: 'VIEW_SWITCH.MAP' })}
      </button>
    </div>
  );
};

ViewSwitchComponent.propTypes = {
  activeView: PropTypes.oneOf(['schedule', 'map']).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ViewSwitchComponent;
